module.exports = __webpack_public_path__ + "img/145.6.2354b7c4.png";